import React from "react";
import JsonPanel from "@src/components/Common/JsonPanel";

const hasData = (obj: any) => obj && typeof obj === "object" && Object.keys(obj).length > 0;

const MetaBlock = ({ title, data }: { title: string; data: any }) => (
    <section className="sid-subcard">
        <h3 className="sid-subcard__title">{title}</h3>
        {hasData(data) ? (
            // the page keeps its own class on the frame, so its rules still apply
            <JsonPanel data={data} className="sid-json" />
        ) : (
            <div className="sid-empty">No {title.toLowerCase()} available.</div>
        )}
    </section>
);

const Metadata = ({ record }: { record: any }) => (
    <div className="sid-meta-grid">
        <MetaBlock title="Application Metadata" data={record.application?.metadata} />
        <MetaBlock title="Team Metadata" data={record.consumer_team?.metadata} />
    </div>
);

export default Metadata;
